import styles from './Organisation.module.scss'
import {Organisation as OrganisationType} from "@/types/Organisation";
import Place from "@/Atoms/Icons/Place";
import Logo from "@images/logo/logo.svg"
import {PropositionType} from "@/types/constants";
import Panel from "@/Atoms/Panel";


export default function Organisation(
  {
    baseUrl,
    organisation,
  }: {
    baseUrl: string,
    organisation: OrganisationType,
  }
) {

let propositionStyle = styles.propositionFree;
if (organisation.logo && organisation.proposition !== PropositionType.Free){
  propositionStyle = styles.propositionFeatured;
}

  return <Panel
    className={`${styles.container} ${propositionStyle}`}
    href={`${baseUrl}/${organisation.slug}`}
    data-testid={`organisation-${organisation.id}`}
  >
    <div className={styles.image}>
      {organisation.logo
        ? <img src={organisation.logo.url} alt={organisation.name}/>
        : <img src={Logo} alt={''}/>}

    </div>
    <div className={styles.content}>
      <h3>{organisation.name}</h3>
      <p>{organisation.services?.map(service => service.title).join(', ')}</p>
      {organisation.address?.place && <p className={'flex items-center'}><Place/> {organisation.address?.place?.title}</p>}

    </div>
    <div className={styles.footer}>
      <span className={'mt-5 btn'}>Meer info</span>
    </div>
  </Panel>
}
